module.exports = __webpack_public_path__ + "static/media/assignment.bd5fa176.svg";